const EMANDATE = (state = {}, action) => {
  switch (action.type) {
    case 'SET_EMANDATE': {
      return {
        ...state,
        emandate: action.data || {},
      };
    }
    case 'SET_EMANDATE_DETAIS': {
      return {
        ...state,
        emandateDetails: action.data || {},
      };
    }
    case 'SET_AUDIT_TRAILS': {
      return {
        ...state,
        auditTrails: action.data || [],
      };
    }
    default: {
      return state;
    }
  }
};

export default EMANDATE;
